import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExgTabV2ComponentHeaderElement} from '../misc/exg-tab-v2/exg-tab-v2.component';
import {EnumerationService} from '../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ExcPdfviewerv3Component} from '../misc/exc-pdf-viewer-v3/exc-pdfviewerv3.component';
import {of} from 'rxjs';

@Component({
  selector: 'app-formular-template',
  templateUrl: './formular-template.component.html',
  styles: [
  ]
})
export class FormularTemplateComponent extends ExcTranslation implements OnInit {
  @ViewChild(ExcPdfviewerv3Component) VCPdfViewer!: ExcPdfviewerv3Component;

  @Input()
  tabinstance: any;

  Data: any;

  rightTabs: ExgTabV2ComponentHeaderElement[] = [];

  isNew = false;
  loaded = false;
  init = true;
  closeTabinstance = false;

  ID: string | undefined = undefined;
  frmTData: {
    frmTID: string,
    frmTUPT: string | undefined,
    frmT_oeID: string,
    frmT_fileStreamID: string,
    frmTName: string,
    frmTDescription: string,
    frmT_aue_enmIdent_Versicherungsart: number,
    frmTFieldCollection: string
  } = {
    frmTID: '',
    frmTUPT: undefined,
    frmT_oeID: '',
    frmT_fileStreamID: '',
    frmTName: '',
    frmTDescription: '',
    frmT_aue_enmIdent_Versicherungsart: -1,
    frmTFieldCollection: ''
  };

  placeholderItems = [] as any[];
  placeholderSearchText = '';

  viewerurl = '';
  uploadedFile = undefined as any;

  receiptPDFViewer = {
    fileUploaded: (event: any): void => {
      this.uploadedFile = event.file;
    },
    pageClicked: (): void => {

    },
    onDocumentLoaded: async () => {
      if (!this.VCPdfViewer.isFileUploaded) {
        this.VCPdfViewer.viewer.forms.collection.clearAllFormFields();
        setTimeout(() => {
          this.VCPdfViewer.viewer.forms.collection.importFormFields(
            this.frmTData.frmTFieldCollection, true
          );
        }, 100);
        this.VCPdfViewer.isDirty = false;
      }

      this.modalSvc.showToast(
        this.getRessource('MessageViewerReady'),
        'md-toast bg-green',
        'fal fa-check'
      );
      return of(!this.init).toPromise();
    },
    onViewerReady: async () => {
      this.modalSvc.showToast(
        this.getRessource('MessageViewerReady'),
        'md-toast bg-green',
        'fal fa-check'
      );
      return of(!this.init).toPromise();
    }
  };

  constructor(
    private excRestService: ExcRestService,
    private modalSvc: ExgModalService,
    private enumSvc: EnumerationService,
    public excSecurity: ExcSecurityService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
    this.tabinstance.BeforeClose = () => {
      return this.checkBeforeClose();
    };
  }

  initialize(): void {
    this.rightTabs = [
      {
        get caption(): string {
          return 'Platzhalter';
        },
        icon_class: 'fal fa-brackets-square',
        get disabled(): boolean {
          return false;
        },
      },
    ];

    this.viewerurl = this.excRestService.computeUrl('FormularTemplateR_Binary', {
      frmTID: this.Data.frmTID,
    });

    this.excRestService.get(
      this.excRestService.computeUrl('FormularTemplateR', {
        frmTID: this.Data.frmTID
        , fkID: undefined})
      ).subscribe((response: any) => {
        if (response?.success) {
          this.frmTData = response.data.FormularTemplate;
          this.initTemplateKeys(response.data.ForeignData);
          this.loaded = true;
        }
      });
  }

  initTemplateKeys(keys: any): void {
    if (this.placeholderItems.length === 0) {
      for (const key of this.getFieldNames(keys)) {
        const keyTable =
          key.startsWith('aue') ? 'AuftragE_EIS' :
            key.startsWith('au') ? 'Auftrag' :
              key.startsWith('vorg') ? 'Vorgang' :
                key;
        const value = {
          text: keyTable !== key ? this.enumSvc.getFieldCaption(keyTable, key) : key.replace('_', ' ')
          , id: key // Value
        };
        this.placeholderItems.push(value);
      }
    }
  }

  getFieldNames(data: object): string[] {
    return Object.keys(data);
  }

  formularTemplate(cancelSave = false): void {
    this.save(cancelSave);
  }

  save(cancelSave = false): void {
    if (cancelSave) {
      this.VCPdfViewer.isDirty = false;
      this.isNew = false;

      this.modalSvc.showToast(
        this.getResource('Canceled')
        , 'md-toast'
        , 'far fa-window-close'
      );

      this.closeTab();
      return;
    }

    if (!this.VCPdfViewer.isDirty && !this.VCPdfViewer.isFileUploaded) {
      return;
    }

    this.frmTData.frmTFieldCollection = this.VCPdfViewer.viewer.forms.collection.exportFormFields(true);

    if (!this.uploadedFile) {
      this.excRestService.put(this.excRestService.computeUrl('FormularTemplateU', {
        frmTID: this.frmTData.frmTID
      }), this.frmTData).subscribe((response: any) => {
        if (response?.success) {
          this.frmTData = response.data.FormularTemplate;
          this.loaded = true;
          this.VCPdfViewer.isDirty = false;

          this.modalSvc.showToast(
              'Formular gespeichert'
              , 'md-toast bg-green'
              , 'far fa-check');
        }
        this.closeTab();
      });
    } else if (this.uploadedFile) {
      const formData = new FormData();
      formData.append('file[]', this.uploadedFile, this.uploadedFile.name);
      formData.append('DataObject', JSON.stringify(this.frmTData));

      this.excRestService.put(
        this.excRestService.computeUrl('FormularTemplateU_File', {
          frmTID: this.frmTData.frmTID,
        }), formData
      ).subscribe((response: any) => {
        if (response?.success) {
          this.uploadedFile = undefined;
          this.frmTData = response.data.FormularTemplate;
          this.loaded = true;
          this.VCPdfViewer.isDirty = false;

          this.modalSvc.showToast(
            'Formular gespeichert'
            , 'md-toast bg-green'
            , 'far fa-check');
        }
        this.closeTab();
      });
    }
  }

  openModalOeFormularTemplateComponent(config?: any): void {
    this.modalSvc.show('ModalOEFormularTemplateComponent', config)
      .subscribe((rtVal: any) => {
        if (rtVal) {
          if (rtVal?.del) {
            this.excRestService
              .delete(
                this.excRestService.computeUrl('OEFormularTemplateCUD', {
                  oeID: this.frmTData.frmT_oeID,
                }), {
                  frmTID: rtVal.frmTID,
                  frmTUPT: rtVal.frmTUPT
                }
              )
              .subscribe((ret: any) => {
                if (ret.success) {
                  this.modalSvc
                    .showToast('Formular Template gelöscht'
                      , 'md-toast bg-green'
                      , 'far fa-check');
                }
                this.closeTab();
              });
          } else {
            if (rtVal && rtVal.frmTID) {
              const dataObject = {
                frmTName: rtVal.frmTName,
                frmTDescription: rtVal.frmTDescription,
                frmT_aue_enmIdent_Versicherungsart: rtVal.frmT_aue_enmIdent_Versicherungsart,
                frmT_enmIdent_DokTyp: rtVal.frmT_enmIdent_DokTyp,
                frmTID: rtVal.frmTID,
                frmTUPT: rtVal.frmTUPT,
              };

              this.excRestService
                .put(this.excRestService.computeUrl('OEFormularTemplateCUD', {
                  oeID: this.frmTData.frmT_oeID
                }), dataObject)
                .subscribe((ret: any) => {
                  if (ret.success) {
                    Object.assign(this.frmTData, {
                      frmTName: ret.data.FormularTemplate.frmTName,
                      frmTDescription: ret.data.FormularTemplate.frmTDescription,
                      frmT_fileStreamID: ret.data.FormularTemplate.frmT_fileStreamID,
                      frmT_aue_enmIdent_Versicherungsart: ret.data.FormularTemplate.frmT_aue_enmIdent_Versicherungsart,
                      frmT_enmIdent_DokTyp: ret.data.FormularTemplate.frmT_enmIdent_DokTyp,
                    });

                    this.Data.Events?.OE?.Summary?.Reload?.emit();

                    this.modalSvc
                      .showToast('Formular Template gespeichert',
                        'md-toast bg-green',
                        'far fa-check');
                  }
                });
            }
          }
        }
      });
  }

  getPlaceholderItems(): any[] {
    if (this.placeholderSearchText.length === 0) {
      return this.placeholderItems;
    }
    return this.placeholderItems
      .filter(s => s.text?.toLowerCase().includes(this.placeholderSearchText.toLowerCase()));
  }

  async copyToClipboard(text: string): Promise<void> {
    await navigator.clipboard
      .writeText(text);
    this.modalSvc.showToast(
      'in Zwischenablage kopiert',
      'md-toast bg-green',
      'far fa-copy'
    );
  }

  checkBeforeClose(): boolean {
    if (!this.VCPdfViewer?.isDirty && !this.isNew) {
      return true;
    }
    this.modalSvc
      .showSimple(
        this.getGlobal('Attention') + '!',
        this.getResource('UnsavedChanges'),
        true,
        true,
        this.getGlobal('Save'),
        this.getGlobal('Reject')
      )
      .subscribe(async (ret: boolean) => {
        this.closeTabinstance = true;
        this.formularTemplate(!ret);
      });
    return false;
  }

  closeTab(): void {
    if (this.closeTabinstance) {
      this.tabinstance.Close();
    }
  }
}
